import { Box } from '@mui/material';
import React from 'react'

export default function Content(props) {
    const { children } = props;
    return (
        <Box my={5} minHeight={'70vh'}>
            {children}
        </Box>
    )
}
